<script lang="ts">
    import { postMail } from "../../../api"
    import { newNotification, login, filesStore } from "../../../store"
    import AttachementField from "../../widgets/fields/AttachementField.svelte"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import Modal from "../../widgets/Modal.svelte"
    import { _ } from "svelte-i18n"

    export let operation: Operation | OperationOut
    export let position: OperationPosition
    export let loadAttachments: (op: Operation | OperationOut) => Promise<Attachement[]>

    let requestAIState: "loading" | "ok" = null

    let assemblyInstructionAvail = false
    let showAssemblyInstructionModal: boolean = false
    let assemblyInstructionEmail: string
    let files: Attachement[] = null
    async function wrapLoad(operation: Operation | OperationOut) {
        if (!loadAttachments) return
        files = await loadAttachments(operation)
        files?.forEach((f) => {
            if (f.name.match(/\-M\.pdf$/i)) {
                assemblyInstructionAvail = true
            }
        })
        $filesStore[operation.id] = files
        return files
    }

    const postRequestForAssemblyInstructions = () => {
        requestAIState = "loading"

        let postOptions: { operation: Operation | OperationOut; position: OperationPosition; email?: string } = {
            operation,
            position,
        }

        if (!$login) {
            postOptions["email"] = assemblyInstructionEmail
        }

        postMail("requestForAssemblyInstructions", postOptions)
            .then(() => {
                newNotification({
                    class: "success",
                    html: $_("positions.assemblyInstructionSent"),
                    timeout: 10000,
                })
                requestAIState = "ok"
                showAssemblyInstructionModal = false
                assemblyInstructionEmail = ""
            })
            .catch((e) => {
                console.log(e)
                newNotification({
                    class: "error",
                    html: $_("positions.errorOccurred"),
                    timeout: 6000,
                })
                requestAIState = null
            })
    }
    $: wrapLoad(operation)
</script>

<div class="file_list">
    {#if files == null}
        {#if $filesStore[operation?.id]?.length}
            {#each $filesStore[operation.id].filter( (f) => f.name.match(new RegExp("^\\d{7,8}_" + String(operation.collectionName == "operation" ? position?.number : position.origin?.positionNumber || position.number).padStart(3, "0") + "-")) ) as file}
                <AttachementField viaId="{operation.collectionName == 'operation-out'}" {file} {operation} />
            {/each}
        {:else}
            <MiniLoader />
        {/if}
    {:else if files?.length}
        {#each files.filter((f) => {
            return f.name.match(new RegExp("^\\d{7,8}_" + String(operation.collectionName == "operation" ? position?.number : position.origin?.positionNumber || position.number).padStart(3, "0") + "-"))
        }) as file}
            <AttachementField viaId="{operation.collectionName == 'operation-out'}" {file} {operation} />
        {/each}
    {/if}
    {#if !assemblyInstructionAvail && position.instructionsAvailable !== false}
        {#if requestAIState == "loading"}
            <MiniLoader />
        {:else if requestAIState != "ok"}
            <button
                class="btn quest auto-height"
                on:click|stopPropagation="{() => {
                    if ($login) {
                        postRequestForAssemblyInstructions()
                    } else {
                        showAssemblyInstructionModal = true
                    }
                }}"
                ><span class="material-icons">description</span>
                {@html $_("positions.requestAssemblyInstructionBreak")}
            </button>
        {/if}
    {/if}
</div>

{#if showAssemblyInstructionModal}
    <Modal bind:show="{showAssemblyInstructionModal}" size="sm">
        <div slot="header">{$_("positions.requestAssemblyInstruction")}</div>
        <h4>{$_("positions.enterEmailPrompt")}</h4>
        <form on:submit|preventDefault="{postRequestForAssemblyInstructions}">
            <div class="inputholder haslabel">
                <label for="email">{$_("positions.sendAssemblyInstructionTo")}</label>
                <input type="email" bind:value="{assemblyInstructionEmail}" id="email" required />
            </div>
            <div class="layout justify-content-end">
                <button class="btn" type="submit" disabled="{!assemblyInstructionEmail}">
                    {$_("positions.submit")}
                </button>
            </div>
        </form>
    </Modal>
{/if}
